<template>
  <div class="pain py-80px">
    <div class="block-content">
      <block-title :en="pain.title.en" :title="pain.title.value" :sub="pain.title.sub"></block-title>

      <div class="card-container mt-60px">
        <div class="card-item" v-for="item in pain.list" :key="item.title">
          <img class="card-icon" :src="item.icon" alt="" />
          <div class="title" v-html="item.title"></div>
        </div>
      </div>

      <div class="scene-grid mt-22px">
        <div class="scene-item" v-for="item in pain.imgList" :key="item.title">
          <img class="scene-image" :src="item.img" :alt="item.title" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['globalData']),
    pain() {
      return this.globalData['customs-logistics-lock-management'].pain;
    }
  }
};
</script>

<style lang="scss" scoped>
.pain {
  * {
    box-sizing: border-box;
  }
}

.card-container {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 22px;
}

.card-item {
  background: #f2f7fd;
  padding: 40px 30px;
  border-radius: 8px;
  transition: all 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;

  // &:hover {
  //   transform: translateY(-8px);
  //   box-shadow: 5px 8px 20px 0 #dadada;
  // }
}

.card-icon {
  width: 64px;
  height: 64px;
}

.title {
  margin-top: 32px;
  color: #333333;
  font-size: 24px;
  font-weight: 700;
  line-height: 34px;
}

.value {
  margin-top: 18px;
  color: rgba(51, 51, 51, 0.7);
  font-size: 16px;
  line-height: 28px;
}

.scene-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 22px;
}

.scene-item {
  position: relative;
  background: #ffffff;
}

.scene-image {
  display: block;
  width: 100%;
  height: 405px;
  object-fit: cover;
}

.scene-title {
  position: relative;
  z-index: 1;
  padding: 16px 0;
  text-align: center;
  color: #3d3d3d;
  font-size: 20px;
  font-weight: 700;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.2);
}

@media screen and (max-width: 1200px) {
  .card-container {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media screen and (max-width: 900px) {
  .scene-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media screen and (max-width: 640px) {
  .card-container,
  .scene-grid {
    grid-template-columns: 1fr;
  }

  .scene-image {
    height: 220px;
  }
}
</style>
